import { useMemo } from "react";

import { CommandPaletteBucket } from "../types";
import useCommandPaletteRecentActionsBucket from "./useRecentActionsBucket";
import useCommandPaletteSearchBucket from "./useSearchBucket";
import useCommandPaletteSettingsBucket from "./useSettingsBucket";
import useCommandPaletteNavigationBucket from "./useNavigationBucket";
import useCommandPaletteIntegrationsBucket from "./useIntegrationsBucket";
import useCommandPaletteOrganizationSettingsBucket from "./useOrganizationSettingsBucket";
import useCommandPaletteCreateBucket from "./useCreateBucket";
import useCommandPaletteAskInfraAssistantBucket from "./useAskInfraAssistantBucket";

const useCommandPaletteBuckets = (): CommandPaletteBucket[] => {
  const createBucket = useCommandPaletteCreateBucket();
  const settingsBucket = useCommandPaletteSettingsBucket();
  const searchBucket = useCommandPaletteSearchBucket();
  const navigationBucket = useCommandPaletteNavigationBucket();
  const integrationsBucket = useCommandPaletteIntegrationsBucket();
  const organizationSettingsBucket = useCommandPaletteOrganizationSettingsBucket();
  const askInfraAssistantBucket = useCommandPaletteAskInfraAssistantBucket();

  const nonRecentBuckets = useMemo(
    () => [
      createBucket,
      settingsBucket,
      searchBucket,
      navigationBucket,
      integrationsBucket,
      organizationSettingsBucket,
      askInfraAssistantBucket,
    ],
    [
      createBucket,
      settingsBucket,
      searchBucket,
      navigationBucket,
      integrationsBucket,
      organizationSettingsBucket,
      askInfraAssistantBucket,
    ]
  );

  const recentActionsBucket = useCommandPaletteRecentActionsBucket(nonRecentBuckets);

  return useMemo(
    () => [recentActionsBucket, ...nonRecentBuckets].sort((a, b) => a.order - b.order),
    [recentActionsBucket, nonRecentBuckets]
  );
};

export default useCommandPaletteBuckets;
